export const FEATURED_FLAG_KEY_MAPPING = {
  wishlist: "wishlist",
  stadiumUsers: "stadium-users-service",
  sendersChoiceIntl: "senders-choice-intl",
  curatedBoxOnSearchPage: "curated-box-on-search-page",
  goodieBagOnSearchPage: "goodie-bag-on-search-page",
  snackMagicHomePagePixelPerfect: "snack-magic-home-page-pixel-perfect",
  stadiumWallet: "stadium-wallet",
  shopIntegrations: "integrations-enabled",
};

export const {
  wishlist: wishlistFeatureFlag,
  stadiumUsers: stadiumUsersFlag,
  sendersChoiceIntl: sendersChoiceIntlFeatureFlag,
  curatedBoxOnSearchPage: curatedBoxOnSearchPageFeatureFlag,
  goodieBagOnSearchPage: goodieBagOnSearchPageFeatureFlag,
  snackMagicHomePagePixelPerfect: snackMagicHomePagePixelPerfectFeatureFlag,
  stadiumWallet: stadiumWalletFlag,
  shopIntegrations: shopIntegrationsFlag,
} = FEATURED_FLAG_KEY_MAPPING;

export const DEFAULT_REACT_OPTIONS = { useCamelCaseFlagKeys: false };

export const LAUNCH_DARKLY_ANONYMOUS_USER_CONFIG = { key: "GLOBAL", anonymous: true };

export const LAUNCH_DARKLY_DEFAULT_FLAGS = {
  [wishlistFeatureFlag]: false,
  [stadiumUsersFlag]: false,
  [sendersChoiceIntlFeatureFlag]: false,
  [curatedBoxOnSearchPageFeatureFlag]: false,
  [goodieBagOnSearchPageFeatureFlag]: false,
  [snackMagicHomePagePixelPerfectFeatureFlag]: false,
  [stadiumWalletFlag]: false,
  [shopIntegrationsFlag]: false,
};
